import type { AgentPart } from '../../lib/api-types';

export type ArtifactReference = { version: 1; kind: 'note' | 'template' | 'automation'; id: string };
const object = (value: unknown): Record<string, unknown> | undefined =>
  value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : undefined;

/** Only successful server receipts can identify saved work. Never parse assistant text. */
export function artifactReference(part: AgentPart, call?: AgentPart): ArtifactReference | undefined {
  if (part.type !== 'tool_result' || part.error || part.status === 'failed') return;
  const output = object(part.output);
  if (!output || output.success === false) return;
  const card = object(output.artifactCard);
  if (card) {
    if (card.version === 1 && ['note', 'template', 'automation'].includes(String(card.kind)) && typeof card.id === 'string')
      return { version: 1, kind: card.kind as ArtifactReference['kind'], id: card.id };
    return;
  }
  // Historical conversations predate card markers but retain tool inputs and receipts.
  const input = object(call?.input);
  if (part.toolName === 'create_record' && input?.object === 'note' && typeof output.recordId === 'string')
    return { version: 1, kind: 'note', id: output.recordId };
  if (part.toolName === 'manage_email_resources' && ['save', 'get'].includes(String(input?.operation)) &&
      ['templates', 'automations'].includes(String(input?.kind)) && typeof output.id === 'string')
    return { version: 1, kind: input?.kind === 'templates' ? 'template' : 'automation', id: output.id };
}

export function artifactKey(reference: ArtifactReference) { return `${reference.kind}:${reference.id}`; }
